<template>
	<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
</template>

<script>
	import JrEcharts from './index.vue'

	// 雷达图
	export default {
		name: 'RadarChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			chartData: {
				type: Array,
				required: true
			},
			indicator: {
				type: Array,
				required: true
			},
			title: {
				type: String,
				default: ''
			}
		},
		data() {
			return {}
		},
		computed: {
			chartOptions() {
				return {
					// title: {
					// 	text: this.title,
					// 	left: 'center'
					// },
					tooltip: {
						trigger: 'item'
					},
					radar: {
						indicator: this.indicator
					},
					series: [
						{
							type: 'radar',
							data: this.chartData,
							symbol: 'none', // 去除数据点
							lineStyle: {
								color: '#209de4', // 线条颜色
								width: 1 // 线条宽度
							},
							areaStyle: {
								color: 'rgba(172,229,255,.8)' // 修改这里的颜色值
							}
						}
					]
				}
			}
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
